/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getServiceEndpointTypeDecoder,
  getServiceEndpointTypeEncoder,
  type ServiceEndpointType,
  type ServiceEndpointTypeArgs,
} from ".";

/** Service endpoint in DID document */
export type ServiceEndpoint = {
  /** Service identifier (e.g., "agent-api") */
  id: string;
  /** Type of service */
  serviceType: ServiceEndpointType;
  /** Service endpoint URI */
  serviceEndpoint: string;
  /** Optional description */
  description: string;
};

export type ServiceEndpointArgs = {
  /** Service identifier (e.g., "agent-api") */
  id: string;
  /** Type of service */
  serviceType: ServiceEndpointTypeArgs;
  /** Service endpoint URI */
  serviceEndpoint: string;
  /** Optional description */
  description: string;
};

export function getServiceEndpointEncoder(): Encoder<ServiceEndpointArgs> {
  return getStructEncoder([
    ["id", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["serviceType", getServiceEndpointTypeEncoder()],
    [
      "serviceEndpoint",
      addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder()),
    ],
    ["description", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getServiceEndpointDecoder(): Decoder<ServiceEndpoint> {
  return getStructDecoder([
    ["id", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["serviceType", getServiceEndpointTypeDecoder()],
    [
      "serviceEndpoint",
      addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder()),
    ],
    ["description", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getServiceEndpointCodec(): Codec<
  ServiceEndpointArgs,
  ServiceEndpoint
> {
  return combineCodec(getServiceEndpointEncoder(), getServiceEndpointDecoder());
}
